import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header d-flex flex-row justify-content-between" }
const _hoisted_3 = { class: "btn-toolbar" }
const _hoisted_4 = { class: "form-check form-switch" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}
const _hoisted_10 = { class: "mt-1 ps-2" }
const _hoisted_11 = {
  key: 0,
  class: "text-warning small"
}
const _hoisted_12 = {
  key: 1,
  class: "text-danger small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("span", null, [
        _createElementVNode("i", { class: "fas fa-envelope fa-fw me-1" }),
        _createTextVNode("Cambiar Correo Electrónico ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input secondary",
            type: "checkbox",
            role: "switch",
            id: "share-email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.update) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.update]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          type: "email",
          class: "form-control",
          placeholder: "Correo Nuevo",
          "aria-label": "Correo Nuevo",
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validateEmailInput && _ctx.validateEmailInput(...args))),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newEmail) = $event)),
          disabled: !_ctx.update || _ctx.saving
        }, null, 40, _hoisted_7), [
          [_vModelText, _ctx.newEmail]
        ]),
        _createElementVNode("button", {
          class: "btn btn-sm btn-outline-success",
          disabled: !_ctx.update || !_ctx.canChangeEmail || _ctx.saving,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.save()))
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-save fa-fw me-1" }, null, -1)),
          _cache[6] || (_cache[6] = _createTextVNode("Guardar ", -1)),
          (_ctx.saving)
            ? (_openBlock(), _createElementBlock("i", _hoisted_9))
            : _createCommentVNode("", true)
        ], 8, _hoisted_8)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.emailValidation.hasWarning)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fas fa-exclamation-circle fa-fw mx-1" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.emailValidation.userMessage), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.emailValidation.hasError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-exclamation-triangle fa-fw mx-1" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.emailValidation.userMessage), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}